<script setup lang="ts">
import AddonsPage from "@/components/AddonsPage.vue";
</script>

<template>
  <AddonsPage />
</template>

<style scoped lang="scss"></style>
